import { render, staticRenderFns } from "./HelpQuestionModal.vue?vue&type=template&id=688ace34"
import script from "./HelpQuestionModal.vue?vue&type=script&lang=js"
export * from "./HelpQuestionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('688ace34')) {
      api.createRecord('688ace34', component.options)
    } else {
      api.reload('688ace34', component.options)
    }
    module.hot.accept("./HelpQuestionModal.vue?vue&type=template&id=688ace34", function () {
      api.rerender('688ace34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/HelpQuestionModal.vue"
export default component.exports